/**
 * Zone.js configuration flags. Zone.js reads these once, when it loads, so this module must be
 * imported before 'zone.js' (see polyfills.ts). ES imports run in order, but statements in the
 * importing module run only after every import, so the flags cannot live in polyfills.ts itself.
 */

/**
 * Leave `XMLHttpRequest.prototype.onreadystatechange` unpatched.
 *
 * Datadog RUM (`@datadog/browser-core`, xhrObservable.js) assigns `xhr.onreadystatechange` on
 * every request, from inside `send()`. With the property patched, that assignment registers a
 * zone event task in whatever zone called `send()` (the Angular zone, for HttpClient), so every
 * `readystatechange` the request fires (HEADERS_RECEIVED, each LOADING chunk, DONE) ran a full
 * `ApplicationRef.tick()`, two to four or more per request on top of the ones HttpClient itself
 * causes. Unpatched, the handler runs natively, outside any zone, and triggers nothing.
 *
 * Nothing else depends on the patched property: HttpClient listens with
 * `addEventListener('load' | 'error' | ...)`, Zone.js tracks the XHR macrotask through its own
 * unpatched listener, and no app code assigns `onreadystatechange`. Every other XHR event-handler
 * property (`onload`, `onerror`, ... on `XMLHttpRequestEventTarget.prototype`) stays patched.
 */
(window as any).__Zone_ignore_on_properties = [
    {
        target: XMLHttpRequest.prototype,
        ignoreProperties: ['readystatechange'],
    },
];
